// Exported components will be automatically
// bootstrapped into your application
// e.g. import MyComponent from './MyComponent'

import CoreComponents from "./core";
import DialogComponents from "./dialogs";
import Shared from "./shared";
import UserComponents from "./user";

export default {
  ...CoreComponents,
  ...DialogComponents,
  ...Shared,
  ...UserComponents
};
